module.exports = __webpack_public_path__ + "c406f7ed93c08737361d5ff6aa12ec31.MP3";